import { HttpResponse } from "@angular/common/http";
import { PaginatedResponse } from "../models/model";


export function extractPaginatedResponse<T>(response: HttpResponse<T[]>): PaginatedResponse<T> {
  return {
    items: response.body || [],
    totalCount: parseInt(response.headers.get('X-Total-Count') || '0', 10),
    totalPages: parseInt(response.headers.get('X-Total-Pages') || '0', 10),
    page: parseInt(response.headers.get('X-Current-Page') || '1', 10),
    pageSize: parseInt(response.headers.get('X-Page-Size') || '10', 10),
    hasPreviousPage: response.headers.get('X-Has-Previous-Page')?.toLowerCase() === 'true',
    hasNextPage: response.headers.get('X-Has-Next-Page')?.toLowerCase() === 'true'
  };
}
